export default "__VITE_ASSET__l0DROYMN__"